import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function centsToUSD(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_7ddea504-9f0a-4be7-840e-b108b36f5a46/artifacts/q42s5989_8B89595F-2DBB-4A07-8A14-C56C3D339DD2.png";
